/*eslint-disable */

import axios from 'axios';
import {bus} from '@/main';
import moment from 'moment';
import pdfViewer from '../pdf-viewer/index.vue';
import reasonPopup from '../reason-show-popup/index.vue';
import remarkPopup from '../interview-remark-popup/index.vue';

const $ = window.jQuery = require('jquery'); 


export default {
  name: 'completed-interview-list',
  components: {
    'remark-popup' : remarkPopup,
    'pdf-viewer' : pdfViewer,
    'reason-show-popup' : reasonPopup
  },
  props: [],
  data () {
    return {
      selectedUserList:null,
      selectedUserListResults:[],
      domainLocationOrigin:'',
      listInfoDisplayState:'all_selected',
      listDisplayState:true,
      notSelectedList:null,
      notSelectedListResults:[],
      missedInterviewList:null,
      missedInterviewListResults:[],
      remarkPopupShowState:false,
      pdfViewerPopup:false,
      pdfViewerFileName:'',
      pdfViewerUrl:'',
      reasonText:'',
      reasonShowState:false,
      remarkText:'',
    }
  },
  computed: {
  },
  mounted () {
    this.domainLocationOrigin = process.env.VUE_APP_PUBLIC_URL
    bus.$on('pdfViewerPopupBus', (data) => {
      this.pdfViewerPopup = data;
    });
    bus.$on('reasonShowStateBus', (data) => {
      this.reasonShowState = data;
    });
    bus.$on('remarkPopupShowStateeBus', (data) => {
      this.remarkPopupShowState = data;
    });
    this.getAllUpcomingInterviewListMethod();
  },
  methods: {
    reasonShowMethod(data){
      this.reasonText = data
      this.reasonShowState = true
      document.body.classList.add('body_right_scroll_remove')
    },
    interviewInfoPopup(arg){
      if(arg == 'all_selected'){
        this.listInfoDisplayState = arg
        this.getAllUpcomingInterviewListMethod()
      }else if(arg == 'all_rejected'){
        this.listInfoDisplayState = arg
        this.getMyInterviewListMethod()
      }
    },
    getAllUpcomingInterviewListMethod(){
      this.$store.dispatch('getFilterInterviewListFun', {filter_key:'is_selected'}).then((res) => {
        this.selectedUserList = res.data.data
        this.selectedUserListResults = this.selectedUserList.results
      })
    },
    getMyInterviewListMethod(){
      this.$store.dispatch('getFilterInterviewListFun', {filter_key:'is_not_selected'}).then((res) => {
        this.notSelectedList = res.data.data
        this.notSelectedListResults = this.notSelectedList.results
      })
    },
    statusCheckOfMeeting(startTime){
      var curentDateUTC = moment().format();
      if (startTime > curentDateUTC){
        return true;
      }else{   
        return false;
      }
    },
    urlClipBoardMethod(value) {
      const copyUrl = this.domainLocationOrigin + '/interview/#' + value
      navigator.clipboard.writeText(copyUrl);
    },
    enabledJoinBtn(joinStartTime, joinEndTime) {
      var currentLocalDate = moment().format('MMMM Do YYYY');
      var currentLocalTime = moment().format('HH:mm:ss');
      var startDateCheck = moment(joinStartTime).format('MMMM Do YYYY')
      var startTimeCheck = moment(joinStartTime).format('HH:mm:ss')
      var endTimeCheck = moment(joinEndTime).format('HH:mm:ss')
      if(startDateCheck === currentLocalDate){
        if (currentLocalTime > startTimeCheck && endTimeCheck > currentLocalTime){
          return true;
        }else{   
          return false;
        }
      }else{
        return false;
      }
    },
    showLoadMoreDataFun(url) {
      this.userLoading = true
      axios.get(url).then((response) => {
          this.loadmoreData = response.data
          this.nextStep = this.loadmoreData.data.next
          this.$set(this.selectedUserListResults, 'next', this.nextStep)
          if (this.loadmoreData != undefined) {
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.selectedUserListResults.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
          }
        });
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
    pdfViewerFun(url){
      var getName = url.split("?")[0].split("/")
      const fileName = getName[getName.length - 1]
      this.pdfViewerFileName = fileName
      this.pdfViewerUrl = url
      this.pdfViewerPopup = true
      $('body').addClass("pdf_view_actv")
    },
    rescheduledViewerFun(remark){
      this.remarkPopupShowState = true
      this.remarkText = remark
      document.body.classList.add('body_right_scroll_remove')
    }
  },
  watch:{
  },
  beforeCreate: function() {
  },
  beforeRouteLeave: function(to, from, next) {
    $("body").removeClass("body_right_scroll_remove");
    $('body').removeClass("pdf_view_actv")
    next();
  },
}